import * as TYPES from './Proximity.types';

export const setProximitySelection = (selection) => ({
  type: TYPES.SET_PROXIMITY_SELECTION,
  payload: selection,
});

export const updateProximitySelection = (updates) => ({
  type: TYPES.UPDATE_PROXIMITY_SELECTION,
  payload: updates,
});

export const resetProximitySelection = () => ({
  type: TYPES.RESET_PROXIMITY_SELECTION,
});

export const setLastAppliedProximity = (selection) => ({
  type: TYPES.SET_LAST_APPLIED_PROXIMITY,
  payload: selection,
});
